
import React, { useContext, useMemo } from 'react';
import { Col, Select, Typography } from 'antd';
import { MyContext } from '../../context/myContext';
import { getProductList, storeProductList } from '../../utils/DataService';
import { IProduct } from '../../interfaces/IProduct';

interface IProductDropdown {
}

const { Option } = Select;
const { Text } = Typography;

const ProductDropdown: React.FC<IProductDropdown> = () => {
  const { setSelectedProduct } = useContext<any>(MyContext);
  const productList = JSON.parse(getProductList()) || [];

  const onChangeHandler = (e: string) => {
    const updatedProductList = productList.map((obj: any) => ({
      ...obj,
      isSelected: obj.name === e
    }));
    storeProductList(JSON.stringify(updatedProductList))
    setSelectedProduct(e)
  }

  const memoisedSelectedProduct = useMemo(() => {
    return productList?.find((item: IProduct) => item?.isSelected)?.name ?? productList[0].name
  }, [productList])



  return (productList && productList?.length > 1 ?


    <Col span={24}>
      <Col span={24}>
        <Text>Products</Text>
      </Col>
      <div className="custom-dropdown-wrapper">
        <Select
          style={{ width: "100%" }}
          className='custom-dropdown'
          onChange={onChangeHandler}
          value={memoisedSelectedProduct}
        >
          {productList.map((release: any) => (
            <Option key={release} value={release?.name}>
              {release?.name}
            </Option>
          ))}
        </Select>
      </div>
    </Col>

    :
    null
  );
};

export default ProductDropdown;
